<template>
  <div class="tx-map">
    <el-row class="control-container">
      <el-col :span="4">
        <el-button @click="goBack">返回</el-button>
      </el-col>
      <el-col :span="9">
        <el-form class="margin-top">
          <el-form-item>
            <el-select v-model="cityCode" placeholder="选择城市" clearable="clearable" autocomplete="off">
              <el-option v-for="item in cityOptions" :key="item.value" :label="item.text" :value="item.value"/>
            </el-select>
          </el-form-item>
        </el-form>
      </el-col>
      <el-col :span="9">
        <el-form class="margin-top">
          <el-form-item>
            <el-select v-model="businessType" placeholder="选择服务类型" clearable="clearable" autocomplete="off">
              <el-option v-for="item in typeOptions" :key="item.index" :label="item.text" :value="item.value"/>
            </el-select>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <tlbs-map
      api-key="ZAEBZ-JZ26W-E2ARN-YAWD4-6XEBQ-D3B5Z"
      ref="mapRef"
      :zoom="15"
      :control="control"
      :center="center"
      :options="mapOptions"
      @click="onClick"
      @map_inited="onMapInited"
    >
      <tlbs-multi-marker
        v-if="geometries && geometries.length > 0"
        ref="markerRef"
        :geometries="geometries"
        :styles="markerStyles"
        :options="markerOptions"
        @click="onMarkerClick"
      />

    </tlbs-map>
    <el-dialog :visible.sync="mapMessageDialogVisible"
               custom-class="bm-control__dialog"
               width="100%"
               :modal="false"
               :append-to-body="true"
    >
      <div class="bm-control-dialog__map-message">
        <div class="title-wrapper">
          <h4 class="facility-name">{{ markerPosition.facilityName }}</h4>
          <div class="business-status-box"
               :class="{ 'open': markerPosition.isBusinessHours , 'closed': !markerPosition.isBusinessHours }"
          >
            {{ markerPosition.isBusinessHours ? '营业中' : '休息中' }}
          </div>
        </div>
        <p class="facility-address" @click="copy(markerPosition.facilityAddress)"><i
          class="el-icon-location-outline"
        />{{ markerPosition.facilityAddress }}<span class="icon-color">复制</span>
        </p>
        <p class="facility-text">{{ markerPosition.dinstanceFmt }}</p>
        <p class="facility-time"><i class="el-icon-time" />上午:{{ markerPosition.amTime }} 下午:{{ markerPosition.pmTime }}</p>
        <div class="facility-service">
          <div class="service" v-if="markerPosition.serviceType && markerPosition.serviceType.includes(1005001)">
            <div class="icon-div">
              <img src="../assets/icon_per.png" class="icon-img">
              <span>个人详版查询</span>
            </div>
          </div>
          <div class="service" v-if="markerPosition.serviceType && markerPosition.serviceType.includes(1005002)">
            <div class="icon-div">
              <img src="../assets/icon_smart.png" class="icon-img">
              <span>个人简版查询</span>
            </div>
          </div>
          <div class="service" v-if="markerPosition.serviceType && markerPosition.serviceType.includes(1005003)">
            <div class="icon-div">
              <img src="../assets/icon_per_hk.png" class="icon-img">
              <span>个人港澳台回乡证查询</span>
            </div>
          </div>
          <div class="service" v-if="markerPosition.serviceType && markerPosition.serviceType.includes(1005004)">
            <div class="icon-div">
              <img src="../assets/icon_ent.png" class="icon-img">
              <span>企业电子营业执照授权查询</span>
            </div>
          </div>
          <div class="service" v-if="markerPosition.serviceType && markerPosition.serviceType.includes(1005005)">
            <div class="icon-div">
              <img src="../assets/per_statement.png" class="icon-img">
              <span>人工柜台服务</span>
            </div>
          </div>
        </div>
        <div v-if="!miniprogram" class="button-div">
          <el-button size="mini" @click="openLocation(markerPosition)">导航去这里</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import axios from "axios";
import wxUtil from "@/utils/WxUtil";
import TxMapUtil from "@/utils/TxMapUtil";

export default {
  data() {
    return {
      miniprogram: window.miniprogram,
      markerPosition: {},
      mapMessageDialogVisible: false,
      currentLocation: '',
      routerParams: {},
      geometries: [],
      facilityList: [],
      center: {
        lat: '36.052349',
        lng: '103.848068',
      },
      isChosen: 'N',
      cityCode: '',
      businessType: null,
      cityOptions: [
        {value: '620100', text: '兰州市', lng: '103.848068', lat: '36.052349'},
        {value: '620200', text: '嘉峪关市', lng: '98.274780', lat: '39.785629'},
        {value: '620300', text: '金昌市', lng: '102.187965', lat: '38.521347'},
        {value: '620400', text: '白银市', lng: '104.176484', lat: '36.556052'},
        {value: '620500', text: '天水市', lng: '105.895766', lat: '34.573212'},
        {value: '620600', text: '武威市', lng: '102.637833', lat: '37.92893'},
        {value: '620700', text: '张掖市', lng: '100.433091', lat: '38.936279'},
        {value: '620800', text: '平凉市', lng: '106.655349', lat: '35.548876'},
        {value: '620900', text: '酒泉市', lng: '98.492485', lat: '39.736890'},
        {value: '621000', text: '庆阳市', lng: '107.645599', lat: '35.717443'},
        {value: '621100', text: '定西市', lng: '104.611512', lat: '35.597289'},
        {value: '621200', text: '陇南市', lng: '104.882243', lat: '33.403865'},
        {value: '622900', text: '临夏回族自治州', lng: '103.210383', lat: '35.601813'},
        {value: '623000', text: '甘南藏族自治州', lng: '102.911659', lat: '34.983274'}
      ],
      typeOptions: [
        {index: 0, value: 1005001, text: '个人详版查询'},
        {index: 1, value: 1005002, text: '个人简版查询'},
        {index: 2, value: 1005003, text: '个人港澳台回乡证查询'},
        {index: 3, value: 1005004, text: '企业电子营业执照授权查询'},
        {index: 4, value: 1005005, text: '人工柜台服务'}
      ],

      mapRef: null,
      control: {
        scale: {},
        zoom: {
          position: 'topRight',
        },
      },
      mapOptions: {
        // 是否显示地图上的控件，默认true。
        // showControl: false,
        renderOptions: {
          renderOptions: true,
        },
      },
      markerStyles: {
        marker: {
          anchor: {x: 10, y: 30},
          offset: {x: 0, y: 30}
        },
      },
      markerOptions: {
        minZoom: 5,
        maxZoom: 15,
      },
    }
  },
  methods: {
    onMapInited() {
      const canvas = document.getElementsByTagName('canvas')[0];
      canvas.style.width = '100%';
      canvas.style.height = '100vh';
    },
    onClick(e) {
      console.log('地图点击事件:', e)
    },
    onMarkerClick(e) {
      const facilityInfo = e.geometry.properties;
      this.markerPosition = facilityInfo;
      this.mapMessageDialogVisible = true;
    },
    goBack() {
      this.$router.go(-1);
    },
    renderMakers() {
      this.$nextTick(() => {
        this.geometries = [];
        if (this.facilityList && this.facilityList.length > 0) {
          this.facilityList.forEach(item => {
            const longitude = item.longitude;
            if (longitude) {
              const lat = longitude.split(',')[1];
              const lng = longitude.split(',')[0];
              this.geometries.push({
                styleId: 'marker',
                position: {
                  lng: lng,
                  lat: lat
                },
                properties: {
                  ...item,
                }
              });
            }
          })
        }

        if (this.currentLocation) {
          this.geometries.push({
            styleId: 'marker',
            position: {
              lng: this.currentLocation.split(',')[0],
              lat: this.currentLocation.split(',')[1],
            },
            content: '当前位置',
          })
        }
      })
    },
    openLocation(item) {
      if (this.miniprogram){
        wxUtil.openLocation(item.lat, item.lng, item.facilityName, item.facilityAddress, '', '');
      } else {
        TxMapUtil.navigate(item);
        console.log('openLocation', this.$refs.mapRef);
        console.log('TMap', window.TMap);
        console.log('TMap.service', window.TMap.service);
      }
    },
    copy(text){
      if (text && navigator.clipboard){
        navigator.clipboard.writeText(text).then(() => {
          this.$alert('成功复制地址', '甘肃征信服务')
        }).catch(() => {
          this.$alert('复制地址失败', '甘肃征信服务')
        })
      } else {
        this.$message.info('暂不支持复制')
      }
    },
    getListData() {
      axios.post(this.$config.baseUrl + '/appointment-web/facilityController/getFacilityList', {
        cityCode: this.cityCode,
        type: this.businessType,
        location: this.location,
        isChosen: this.isChosen
      }, {headers: {'Content-Type': 'application/json'}})
        .then(response => {
          if (response.data && response.data.facilityList) {
            this.facilityList = response.data.facilityList;
          } else {
            this.facilityList = [];
          }
          this.renderMakers();
        })
        .catch(error => {
          console.log('请求错误:', error)
        })
    },
  },
  watch: {
    businessType(newValue) {
      this.isChosen = 'Y';
      this.getListData()
    },
    cityCode(newValue) {
      this.isChosen = 'Y';
      this.cityCode = newValue;
      const city = this.cityOptions.find(item => {
        return item.value === newValue
      });
      this.center = {
        lat: city ? city.lat : this.center.lat,
        lng: city ? city.lng : this.center.lng
      }
      this.getListData()
    },
  },
  mounted() {
    const params = this.$route.params;
    this.routerParams = params;
    if (params.facilityList){
      this.facilityList = params.facilityList;
      this.renderMakers();
    } else {
      this.getListData();
    }

    if (params.location) {
      this.center = {
        lat: params.location.split(',')[1],
        lng: params.location.split(',')[0]
      }
    }

    if (params.currentCityCode) {
      this.cityCode = params.currentCityCode;
    }

    if (params.currentBusinessType) {
      this.businessType = params.currentBusinessType;
    }

    if (params.location) {
      this.currentLocation = params.location;
    }
  },
}

</script>

<style scoped>
.tx-map {
  width: 100%;
  height: 100vh;
  position: relative;
}

.control-container {
  position: absolute;
  top: 20px;
  left: 0;
  z-index: 1001;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
}

::v-deep .bm-control__dialog .el-dialog__header{
  border-bottom: none;
  margin: 0;
  padding: 2% 0;
}

::v-deep .bm-control__dialog{
  margin-top: 0;
  position: fixed !important;
  bottom: 0 !important;
  left: 0 !important;
  margin-bottom: 0 !important;
  transform: none !important;
  border-radius: 8px 8px 0 0;
  z-index: 9999;
}

::v-deep .bm-control__dialog .el-dialog__body {
  padding: 0 !important;
}

.bm-control-dialog__map-message{
  padding: 2%;
}

.title-wrapper {
  display: flex;
  align-items: center;
  padding-bottom: 5px;
  font-size: 16px;
}

.facility-name {
  margin: 0;
  font-weight: 400;
  font-size: 17px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  word-break: break-all;
}

.facility-speaker {
  font-size: 16px;
  color: #b22d32;
  cursor: pointer;
  margin-left: 5px;
  align-self: center;
}

.facility-text {
  color: #b7b7b7;
  margin: 2% 0;
  font-size: 12px;
}

.business-status-box {
  display: inline-block;
  padding: 5px;
  border-radius: 5px;
  font-weight: bold;
  font-size: 14px;
  margin-left: 5px;
  white-space: nowrap;
}

.facility-address {
  margin: 2% 0;
  color: #999;
  font-size: 13px;
}

.facility-time {
  margin: 0;
  padding-bottom: 5px;
  font-size: 12px;
  color: #a3a3a3;
}

.facility-service {
  display: flex;
  flex-wrap: wrap;
  font-size: 12px;
}

.service {
  padding: 3px 0;
  margin-right: 2px;
  font-size: 12px;
}

.icon-img {
  max-height: 15px;
  max-width: 15px;
}

.icon-div {
  color: #2696e8;
  display: flex;
  flex-direction: row;
  align-items: center;
}

.button-div {
  padding: 20px 0;
  display: flex;
  text-align: center;
}

.icon-color {
  margin-left: .3rem;
  color: #2696e8;
}
</style>
